import { render, staticRenderFns } from "./tab-creative.vue?vue&type=template&id=65c935bd&scoped=true"
import script from "./tab-creative.vue?vue&type=script&lang=js"
export * from "./tab-creative.vue?vue&type=script&lang=js"
import style0 from "./tab-creative.vue?vue&type=style&index=0&id=65c935bd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c935bd",
  null
  
)

export default component.exports